import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;


export async function getCurrencies(){
  return await axiosInstance.get(`${backendUrl}/api/currencies`);

}

export async function getSubcategoriesSearch(page,pageSize, search){
  return await axiosInstance.get(`${backendUrl}/api/subcategories/all`, {
                params: {
                    page: page,
                    size: pageSize,
                    search: search || "", // Send the filter value to the backend
                    // You can also add sort: 'columnName,desc' if needed
                }
  });
}

export async function getSubcategories(){
  return await axiosInstance.get(`${backendUrl}/api/subcategories`);
}

export async function saveSubcategories(data) {
  const res = await axiosInstance.post(`${backendUrl}/api/subcategories`, data);
  return res.data;
}

export async function updateSubcategories(id, data) {

  const res = await axiosInstance.put(`${backendUrl}/api/subcategories/${id}`, data);
  return res.data;
}

 export async function deleteSubcategories(id) {
   const res = await axiosInstance.delete(`${backendUrl}/api/subcategories/${id}`);
  return res.data;
  }


export async function getCategories(){
  return await axiosInstance.get(`${backendUrl}/api/categories`);
}

export async function saveCategories(data) {
  const res = await axiosInstance.post(`${backendUrl}/api/categories`, data);
  return res.data;
}

export async function updateCategories(id, data) {

  const res = await axiosInstance.put(`${backendUrl}/api/categories/${id}`, data);
  return res.data;
}

 export async function deleteCategories(id) {
   const res = await axiosInstance.delete(`${backendUrl}/api/categories/${id}`);
  return res.data;
  }